import { FormGroup } from '@angular/forms';

export class FormUtils {
  static markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        FormUtils.markFormGroupTouched(control);
      }
    });
  }
}
